import { Calendar, DatePicker } from '@beef/ui-kit';
import React from 'react';
import classNames from 'classnames/bind';

import { DatePickerWrapperProps } from 'components/DatePickerWrapper/type';

import styles from './styles.pcss';

const cn = classNames.bind(styles);

export const DatePickerWrapper = ({
  className,
  maxDate,
  minDate,
  onChange,
  isMobile,
}: DatePickerWrapperProps) => {
  if (isMobile) {
    return (
      <Calendar
        className={cn(className, 'calendar-wrapper')}
        maxDate={maxDate}
        minDate={minDate}
        onChange={onChange}
        value={minDate}
      />
    );
  }

  return (
    <DatePicker
      className="mar-t-m"
      maxDate={maxDate}
      minDate={minDate}
      name="lockDate"
      onChange={onChange}
      value={minDate}
    />
  );
};
